(function () {
  const tooltipSelector = '[data-cys-tooltip]';
  const triggerSelector = '.cys-tooltip__trigger';
  const panelSelector = '.cys-tooltip__panel';
  const iconSelector = '.cys-tooltip__icon';
  const SHIFT_VAR = '--cys-tooltip-shift';
  const POINTER_SHIFT_VAR = '--cys-tooltip-pointer-shift';
  const VIEWPORT_PADDING = 16;
  let activeTooltip = null;

  function getParts(tooltip) {
    if (!tooltip) return {};
    const trigger = tooltip.querySelector(triggerSelector);
    const panel = tooltip.querySelector(panelSelector);
    return { trigger, panel };
  }

  function openTooltip(tooltip) {
    const { trigger, panel } = getParts(tooltip);
    if (!trigger || !panel) return;

    if (activeTooltip && activeTooltip !== tooltip) {
      closeTooltip(activeTooltip);
    }

    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    tooltip.classList.add('is-active');
    activeTooltip = tooltip;

    requestAnimationFrame(() => {
      positionTooltip(tooltip);
    });
  }

  function closeTooltip(tooltip) {
    const { trigger, panel } = getParts(tooltip);
    if (!trigger || !panel) return;

    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    tooltip.classList.remove('is-active');
    panel.style.removeProperty(SHIFT_VAR);
    panel.style.removeProperty(POINTER_SHIFT_VAR);
    if (activeTooltip === tooltip) {
      activeTooltip = null;
    }
  }

  function toggleTooltip(tooltip) {
    if (!tooltip) return;
    if (tooltip === activeTooltip) {
      closeTooltip(tooltip);
    } else {
      openTooltip(tooltip);
    }
  }

  function handleDocumentClick(event) {
    if (!activeTooltip) return;
    const tooltip = event.target.closest(tooltipSelector);
    const clickedInsideActive = tooltip && tooltip === activeTooltip;

    if (!clickedInsideActive) {
      closeTooltip(activeTooltip);
    }
  }

  function handleEscape(event) {
    if (event.key === 'Escape' && activeTooltip) {
      closeTooltip(activeTooltip);
    }
  }

  function positionTooltip(tooltip) {
    const { trigger, panel } = getParts(tooltip);
    if (!trigger || !panel) return;

    const icon = trigger.querySelector(iconSelector) || trigger;

    const iconRect = icon.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const panelRect = panel.getBoundingClientRect();

    const panelWidth = panelRect.width || panel.offsetWidth;
    if (!panelWidth) return;

    const iconCenter = iconRect.left + iconRect.width / 2;
    const tooltipCenter = tooltipRect.left + tooltipRect.width / 2;

    let panelLeft = iconCenter - panelWidth / 2;
    const minLeft = VIEWPORT_PADDING;
    const maxLeft = Math.max(VIEWPORT_PADDING, document.documentElement.clientWidth - VIEWPORT_PADDING - panelWidth);
    panelLeft = Math.min(Math.max(panelLeft, minLeft), maxLeft);

    const panelCenter = panelLeft + panelWidth / 2;
    const shift = panelCenter - tooltipCenter;
    const pointerLimit = Math.max(0, panelWidth / 2 - 14);
    const pointerShiftRaw = iconCenter - panelCenter;
    const pointerShift = Math.min(Math.max(pointerShiftRaw, -pointerLimit), pointerLimit);

    panel.style.setProperty(SHIFT_VAR, `${shift}px`);
    panel.style.setProperty(POINTER_SHIFT_VAR, `${pointerShift}px`);
  }

  function initTooltip(tooltip) {
    if (!tooltip || tooltip.dataset.cysTooltipInitialized === 'true') return;
    const { trigger, panel } = getParts(tooltip);
    if (!trigger || !panel) return;

    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      toggleTooltip(tooltip);
    });

    const closeButton = panel.querySelector('[data-cys-tooltip-close]');
    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        closeTooltip(tooltip);
      });
    }

    tooltip.dataset.cysTooltipInitialized = 'true';
  }

  function initAll() {
    const tooltips = document.querySelectorAll(tooltipSelector);
    tooltips.forEach(initTooltip);
  }

  document.addEventListener('click', handleDocumentClick);
  document.addEventListener('keydown', handleEscape);
  window.addEventListener('resize', () => {
    if (!activeTooltip) return;
    if (!document.body.contains(activeTooltip)) {
      activeTooltip = null;
      return;
    }
    positionTooltip(activeTooltip);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', (event) => {
    const tooltip = event.target && event.target.querySelector(tooltipSelector);
    if (tooltip && tooltip === activeTooltip) {
      closeTooltip(tooltip);
    }
  });
})();
